<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-4">
            <div class="mb-4">
                <h1 class="text-first">
                    {{ $t('Auth.ForgotPassword.RouteName') }}
                </h1>
            </div>
            <form class="shadow rounded p-4" @submit.prevent="resetPassword">
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="newPasswordShowed === false ? 'password' : 'text'" v-model="new_password" class="border-bottom" id="new_password" :class="{ 'text-danger': errors.new_password }" required>
                        <label for="new_password" :class="{ 'text-danger': errors.new_password }">
                            <i class="fa-solid fa-lock me-1"></i>
                            {{ $t('Auth.ResetPassword.new_password') }}
                            <small v-if="errors.new_password" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.new_password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle" role="button" @click="newPasswordShowed = !newPasswordShowed">
                            <i class="fa-solid" :class="newPasswordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="confirmNewPasswordShowed === false ? 'password' : 'text'" v-model="confirm_new_password" class="border-bottom" id="confirm_new_password" :class="{ 'text-danger': errors.confirm_new_password }" required>
                        <label for="confirm_new_password" :class="{ 'text-danger': errors.confirm_new_password }">
                            <i class="fa-solid fa-lock me-1"></i>
                            {{ $t('Auth.ResetPassword.confirm_new_password') }}
                            <small v-if="errors.confirm_new_password" class="text-danger">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.confirm_new_password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle" role="button" @click="confirmNewPasswordShowed = !confirmNewPasswordShowed">
                            <i class="fa-solid" :class="confirmNewPasswordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <button type="submit" class="btn btn-auth btn-auth-third w-100">
                    {{ $t('Auth.ResetPassword.reset_password') }}
                </button>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ResetPassword',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    data() {
        return {
            new_password: null,
            confirm_new_password: null,
            newPasswordShowed: false,
            confirmNewPasswordShowed: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        resetPassword() {
            this.$http
                .post(`${this.apiPath}/reset_password`, { token: this.$route.query.token, new_password: this.new_password, confirm_new_password: this.confirm_new_password }, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                }).then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'new_password') {
                                this.errors.new_password = this.$t(`Auth.ResetPassword.errors.new_password.${error.msg}`)
                            }
                            if (error.path == 'confirm_new_password') {
                                this.errors.confirm_new_password = this.$t(`Auth.ResetPassword.errors.confirm_new_password.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                        return
                    }
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            this.$router.replace('/')
                            break
                        default:
                            this.$toast.success(this.$t('Auth.PasswordResetSucceeded.succeeded'))
                            this.$router.replace('/')
                            break
                    }
                }).catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>